import RichText from '@commons/components/RichText';
import type { DrupalBlock, DrupalText } from '@commons/types/drupal';

/**
 * InsightIntroduction field block.
 */

const InsightIntroductionBlock = ({ content }: DrupalBlock<DrupalText>) => {
  if (!content) return null;

  const text = content?.value || '';

  return <RichText width={12} value={text} marginTop="xl" />;
};

export default InsightIntroductionBlock;
